import logo from '@/assets/logos/fm-rgb-logo.png'
import { defineStore } from 'pinia'
import { useRoute } from 'vue-router'

import { computed, nextTick, onBeforeMount, ref } from 'vue'

import {
  authLayoutThemeManager,
  setThemeColor,
} from '@/features/auth/layout/authLayoutThemeManager.js'
import { useClubTheming } from '@/features/auth/layout/useClubTheming.js'
import { getActiveClubId } from '@/features/router/useActiveClub.js'
import { appendHashIfNotExists } from '@/features/utils/color.utils.js'

export const useAuthLayoutStore = defineStore('authLayoutStore', () => {
  const route = useRoute()

  const logoRef = ref(logo)
  const fmLogo = logo
  const isPreviewMode = ref(false)

  const isLoadingRef = ref(false)

  const sponsorLogos = [
    'https://dummyimage.com/200x100/000/fff',
    'https://dummyimage.com/100x50/000/fff',
    'https://dummyimage.com/50x80/000/fff',
  ]

  const isClubLogin = computed(() => {
    return getActiveClubId()
  })

  function reset() {
    console.log('Resetting theme with force update')
    setClubLogo(fmLogo)
    authLayoutThemeManager.resetAllProperties()
    setIsPreview(false)
  }

  const { fetchClubTheme } = useClubTheming(getActiveClubId())
  async function handleSetPreset() {
    const isClubRegister = route.name === 'clubRegister'

    // If it's club register, don't set the theme because we set it manually
    if (isClubRegister) {
      return
    }

    if (!isClubLogin.value) {
      console.log('No club login, resetting...')
      reset()
      return
    }

    console.log('Setting club theme...')

    try {
      isLoadingRef.value = true

      const { logo, background, brandColors } = await fetchClubTheme()

      // If we have logo, set it
      if (logo) {
        setClubLogo(logo)
      }

      const authLayoutWrapper = document.querySelector('.auth-layout-wrapper')

      // If we have background, set it
      if (authLayoutWrapper && background) {
        authLayoutWrapper.style.setProperty(
          '--fm-ui-auth-layout-background-image',
          `url(${background})`,
        )
      }

      // If we have brand colors, set them
      await nextTick(() => {
        setThemeColors({
          backgroundColor: appendHashIfNotExists(brandColors?.background),
          textColor: appendHashIfNotExists(brandColors?.text),
        })
      })
    } catch (e) {
      console.error('Error while setting club theme:', e)
    } finally {
      isLoadingRef.value = false
    }
  }

  onBeforeMount(async () => {
    await handleSetPreset()
  })

  function setClubLogo(logo) {
    logoRef.value = logo
  }

  function setThemeColors({ backgroundColor, textColor }) {
    setThemeColor({
      backgroundColor,
      textColor,
    })
  }

  function setIsPreview(mode) {
    isPreviewMode.value = mode
  }

  function $reset() {
    logoRef.value = logo
    isPreviewMode.value = false
    isLoadingRef.value = false
    authLayoutThemeManager.resetAllProperties()
  }

  return {
    $reset,
    sponsorLogos,
    clubLogo: logoRef,
    isClubLogin,
    setThemeColors,
    setClubLogo,
    setIsPreview,
    isPreviewMode,
    reset,
    isLoadingRef,
  }
})
